import { IncludeInfo } from "src/app/domainObjects/includeInfo";
import { ParameterSetting } from "src/app/domainObjects/masterConfig";
import { SortInfo } from "src/app/domainObjects/sortInfo";
import { OptionItem, OptionItemDataType } from "src/app/model/optionItem";
import { ValidationInfo } from "src/app/objectModel/validationInfo";

export class TransformerParametersViewModel {
  constructor(){

    this.validationInfo = this.configureValidationInfo();
  }
  configureValidationInfo(): ValidationInfo[] {
    return [];
  }
  sourceColumn: string;
  targetColumn: string;
  userColumn: string;
  timeColumn?: string;
  sortInfo?: SortInfo[];
  includeInResults?: IncludeInfo[];
  sampleStart : number;
  sampleEnd : number;
  runAll: boolean;
  deleteMisses: boolean;
  missName: string;

  sourceColumns: OptionItem[]=[];
  sourceColumnsDT: OptionItemDataType[]=[];
 // sourceColumnsOptions: string[] = [];
  targetColumns: Array<string>=[];
 // targetColumnsOptions: string[] = [];

  validationInfo?: ValidationInfo[]=[];

  getValidationInfo(name: string): ValidationInfo {
    return this.validationInfo.find(f => f.fieldName === name);
  }

}